module.exports = __webpack_public_path__ + "static/img/2_1_3.d5414f23.jpg";